import store from '@/store'
import { UserClaimStatus } from '@/utils/Enumerations.js'

export function userAssignedClaim (...allowedClaims) {
  const userClaims = store.getters['user/userClaims']
  return userClaims.some(uc => uc.value === UserClaimStatus.Allow.value &&
    allowedClaims.some(ac => ac.value === uc.systemClaim))
}
